import http from '@/core/http';

const message = {
  actions: {
    // 消息列表
    MessageList (ctx, payload) {
      return http.req_post('/admin/action/popuplist', { ...payload });
    },
    // 编辑消息列表
    EditOrAddMessage (ctx, payload) {
      return http.req_get('/admin/action/savepopup', { ...payload });
    },
  },
};

export default message;